export default "__VITE_ASSET__CC65U_Yw__"